// AGENCY PORTAL THEME — Yosi Media Studio
// Matte black + charcoal + metallic gold. Kept isolated from client themes.

export const T = {
  bg: "#0A0A0C",
  side: "#0F1013",
  card: "#161719",
  card2: "#1C1D20",
  input: "#0E0F12",
  border: "rgba(255,255,255,0.07)",
  borderHi: "rgba(212,175,55,0.35)",

  gold: "#D4AF37",
  goldHi: "#E5C158",
  goldSoft: "rgba(212,175,55,0.14)",

  text: "#F5F5F7",
  textDim: "rgba(245,245,247,0.62)",
  textFaint: "rgba(245,245,247,0.4)",

  success: "#22C55E",
  info: "#60A5FA",
  warning: "#F59E0B",
  danger: "#EF4444",
  purple: "#A78BFA",

  r: "14px",
  rLg: "18px",
  shadow: "0 8px 32px rgba(0,0,0,0.35)",
};

export const CARD = { background: T.card, border: `1px solid ${T.border}`, borderRadius: T.r };
export const CARD_ELEV = { background: T.card2, border: `1px solid ${T.border}`, borderRadius: T.r };
export const INP = { background: T.input, border: `1px solid ${T.border}`, color: T.text, borderRadius: 10 };

// Agency brand
export const AGENCY_BRAND = {
  name: "Yosi Media Studio",
  tagline: "Agency Portal",
};
